<template>
  <aside class="sidebar">
    <ul>
      <li
        v-for="item in menuItems"
        :key="item.key"
        :class="{ active: activeTab === item.key }"
        @click="select(item.key)"
      >
        {{ item.label }}
      </li>
    </ul>
  </aside>
</template>

<script setup>
import { defineEmits, defineProps, ref, onMounted, computed } from 'vue'
import authService from '../../../services/auth'

const userRole = ref("user")

const props = defineProps({
  activeTab: { type: String, default: 'HomePage' }
})
const emit = defineEmits(['update:activeTab'])

function select(tab) {
  emit('update:activeTab', tab)
}

// 所有側邊欄項目，標記 admin 專用
const allMenuItems = [
  { key: 'HomePage', label: '我的主頁' },
  { key: 'Cart', label: '我的購物車' },
  { key: 'Order', label: '我的訂單' },
  { key: 'Collect', label: '我的收藏' },
  { key: 'ShopManage', label: '商品管理', adminOnly: true },
  { key: 'FrontPage', label: '首頁管理', adminOnly: true },
  { key: 'ArticleManage', label: '熱搜管理', adminOnly: true },
  { key: 'CollectionManage', label: '合作商家', adminOnly: true },
  { key: 'Discount', label: '折價管理', adminOnly: true },
  { key: 'OrderManage', label: '订单管理', adminOnly: true },
]

// 根據角色過濾菜單項目
const menuItems = computed(() => {
  return allMenuItems.filter(item => {
    return !item.adminOnly || userRole.value === 'admin'
  })
})

onMounted(async () => {
  try {
    const result = await authService.getCurrentUser()
    if (result) {
      userRole.value = result.role
    }
  } catch (error) {
    // ElMessage.error(error)
  }
})
</script>

<style scoped>
.sidebar {
  width: 200px;
  padding: 20px;
  box-sizing: border-box;
}
.sidebar ul {
  list-style: none;
  padding: 0;
}
.sidebar li {
  padding: 10px;
  cursor: pointer;
  border-radius: 4px;
  margin-bottom: 8px;
  transition: background-color 0.3s;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sidebar li.active,
.sidebar li:hover {
  background-color: #e0e0e0;
}
</style>